/**
 * @file Why Extract schedule cannot start from one attachment version, or null
 * when it can. Consumers: `AttachmentListActions` (each row) and
 * `AttachmentPreviewOverlay` (its header), so the two never disagree.
 *
 * Reasons are checked in a fixed order and the first that applies wins: the
 * file type, then the host, then the user's right. A non-PDF is told it is not a
 * PDF even on a record, because that is the reason no host could fix.
 */
import type { AttachmentFileType, ExtractScheduleHost } from './index.types';

export const resolveExtractScheduleBlockedReason = (params: {
  fileType: AttachmentFileType;
  host: ExtractScheduleHost;
  canExtract: boolean;
}): string | null => {
  const { fileType, host, canExtract } = params;
  if (fileType !== 'pdf') return 'Only PDFs can be extracted.';
  if (host.kind === 'record')
    return 'Extract onto a form: records take spreadsheets.';
  if (host.kind === 'communicationLog')
    return "Extract onto a form: open the form's Attachments.";
  if (!canExtract) return 'Extracting needs the AI operator right.';
  return null;
};
